import * as React from 'react';

import { Page, UserSelect, Input, Contact, Icon } from 'components';
import styled from 'styled-components';
import { AuthContext, AgentsContext } from 'contexts';

type NewGroupsMainPageProps = {
  groupName: string;
  groupMembers: string[];
  setGroupMembers: React.Dispatch<React.SetStateAction<string[]>>;
  setGroupName: React.Dispatch<React.SetStateAction<string>>;
};

export type SelectedAgents = {
  label: string;
  value: string;
};

const NewGroupsMainPage: React.FC<NewGroupsMainPageProps> = ({
  groupName,
  groupMembers,
  setGroupMembers,
  setGroupName,
}) => {
  const { auth } = React.useContext(AuthContext);
  const { orgUsersMap } = React.useContext(AgentsContext);
  const addAgent = (selectedAgents: string[]) => {
    setGroupMembers(prev => [...prev, ...selectedAgents]);
  };
  const removeAgent = (selectedAgent: string) => {
    setGroupMembers(prev => prev.filter(member => member !== selectedAgent));
  };

  const groupSet = new Set(groupMembers);
  const authorizedLocations =
    auth?.role === 'BRANCH_ADMIN'
      ? [auth?.location, ...(auth?.locations || [])]
      : null;
  return (
    <Page type="filled">
      <MainContent>
        <StyledInputContainer>
          <label>
            <div>Group Name: </div>
            <StyledInput
              value={groupName}
              onChange={e => setGroupName(e.target.value)}
              placeholder="Enter Group Name"
            />
          </label>
        </StyledInputContainer>

        <StyledInputContainer>
          <label>
            <div>Agents: </div>
            <StyledUserSelect
              showSearch
              value={[]}
              locations={authorizedLocations}
              filter={({ id }) => !groupSet.has(id)}
              onChange={addAgent}
              placeholder="Select"
            />
          </label>
        </StyledInputContainer>

        <StyledAgentsCount>
          There are {groupMembers.length} people selected in the group.
        </StyledAgentsCount>

        {groupMembers.length > 0 && (
          <StyledSelectedAgents>
            {groupMembers.map(value => (
              <StyledRemoveFromGroup key={value}>
                <Contact contact={orgUsersMap![value]} showBranchName />
                <button onClick={() => removeAgent(value)}>
                  <Icon type="x" />
                </button>
              </StyledRemoveFromGroup>
            ))}
          </StyledSelectedAgents>
        )}
      </MainContent>
    </Page>
  );
};

export default NewGroupsMainPage;

const StyledRemoveFromGroup = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 475px;
`;

const StyledAgentsCount = styled.div`
  padding: 10px 0;
`;

const StyledInputContainer = styled.div`
  padding-bottom: 10px;
`;

const StyledSelectedAgents = styled.div`
  padding: 0 0 30px 20px;
`;

const StyledInput = styled(Input)`
  max-width: 500px;
`;

const StyledUserSelect = styled(UserSelect)`
  max-width: 500px;
  width: 100%;
`;

const MainContent = styled.div`
  padding: 0px 30px;
  width: 100%;
  height: calc(100vh - 175px);
`;
